import React from "react";
import Hero from "@/components/home/Hero";
import ValueProps from "@/components/home/ValueProps";
import CategoryPreview from "@/components/home/CategoryPreview";
import WhySeisfra from "@/components/home/WhySeisfra";
import ProjectsStrip from "@/components/home/ProjectsStrip";
import NewsTeaser from "@/components/home/NewsTeaser";
import CTABanner from "@/components/site/CTABanner";

export default function Home() {
  return (
    <>
      <Hero />
      <ValueProps />
      <CategoryPreview />
      <WhySeisfra />
      <ProjectsStrip />
      <NewsTeaser />
      <CTABanner />
    </>
  );
}